import { Card } from '../components/ui/Card';
import { TechSelector } from '../components/ui/TechSelector';

import { VideoPlayer } from '/src/components/VideoPlayer';
import { ListItem } from '../components/ui/ListItem';
import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';
import ShopifyPoster from '/src/features/installation/assets/shopify-instructions-poster.jpg';
import ShopifyVideo from '/src/features/installation/assets/shopify-instructions.mp4';

export function ShopifyInstructions({ techOptions = [], selectedTechOption = null, onSelectTech }) {
  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <ol className="flex flex-col gap-4 mb-4">
        <ListItem number={1}>Log into your Shopify account.</ListItem>

        <ListItem number={2}>
          Visit{' '}
          <a
            href="https://apps.shopify.com/crazy-egg"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-dodger-blue-500 hover:underline"
          >
            apps.shopify.com/crazy-egg
          </a>
        </ListItem>

        <ListItem number={3}>
          Click on <strong>Add App.</strong>
        </ListItem>

        <ListItem number={4}>
          You&apos;ll be redirected to the Shopify installation screen. Review the setup information, and click on{' '}
          <strong>Install app.</strong>
        </ListItem>

        <ListItem number={5}>
          Click on <strong>Connect existing account.</strong>
        </ListItem>

        <ListItem number={6}>Enter your Crazy Egg username and password.</ListItem>

        <ListItem number={7}>
          Go to <strong>Themes</strong> under Online Store.
        </ListItem>

        <ListItem number={8}>
          Click on <strong>Customize.</strong>
        </ListItem>

        <ListItem number={9}>
          Select <strong>Theme Settings</strong> in the bottom left corner.
        </ListItem>

        <ListItem number={10}>
          Select <strong>App Embeds.</strong>
        </ListItem>

        <ListItem number={11}>Search for Crazy Egg (if needed.)</ListItem>

        <ListItem number={12}>Enable the Embedded App.</ListItem>

        <ListItem number={13}>
          Click on <strong>Save</strong> in the top right corner.
        </ListItem>
      </ol>

      <p className="mt-10 text-base font-normal leading-6 text-black-pearl-500 mb-3">
        Watch this video to see these steps:
      </p>

      <VideoPlayer src={ShopifyVideo} poster={ShopifyPoster} label="Shopify installation video" />

      <div className="flex flex-col gap-1 mt-3">
        <SupportLink
          href={SupportLinks.install.shopify}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Shopify Setup Guide
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>

      <p className="mt-3 text-black-pearl-500">
        Click on <strong>Check Installation</strong> once you have connected Crazy Egg with Shopify.
      </p>
    </Card>
  );
}
